import * as types from '../actions/actionTypes'
import { stat } from 'fs';


const realtorsReducer = (state = {
    allRealtors: [],
    selectedRealtor: {
      email: "",
      name: "",
      officeName: "",
      region: "",
      uid: ""
    },
    selectedRealtorPoints: {
      currentTotal: 0,
      runningTotal: 0,
      bonusLevelRank: 0,
      bonusLevelName: "",
      realtorsPoints: [],
    }
}, action) => {

    switch(action.type) {
      case types.GET_REALTORS_DATA_SUCCESS: 
      state = {
        ...state,
        allRealtors: action.payload,
      };
      break;
      case types.GET_POINTS_FOR_REALTOR_SUCCESS: 
      state = {
        ...state,
        selectedRealtorPoints: {
          currentTotal: action.payload.currentTotal,
          runningTotal: action.payload.runningTotal,
          bonusLevelRank: action.payload.bonusLevelRank,
          bonusLevelName: action.payload.bonusLevelName,
          realtorsPoints: action.payload.realtorsPoints
        }
      };
      break;
      case types.UPDATE_SELECTED_REALTOR_INFO: 
      state = {
        ...state,
        selectedRealtor: {
          email: action.payload.email,
          name: action.payload.name,
          officeName: action.payload.officeName,
          region: action.payload.region,
          uid: action.payload.uid,
        }
      };
      break;
      case types.CLEAR_SELECTED_REALTOR_POINTS: 
      state = {
        ...state,
        selectedRealtorPoints: {
          currentTotal: 0,
          runningTotal: 0,
          bonusLevelRank: -1,
          bonusLevelName: "",
          realtorsPoints: action.payload
        }
      };
      break;
      case types.REALTOR_POINT_APPROVAL:
      const approvalSelectedRealtorPoints = state.selectedRealtorPoints.realtorsPoints.map(pointObject =>{
        if (pointObject.nodeName === action.payload) {
          pointObject.approved = true
          pointObject.approvedBy = action.payloadTwo
        }
      })

      state = {
        ...state,
        selectedRealtorPoints: {
          currentTotal: state.selectedRealtorPoints.currentTotal,
          runningTotal: state.selectedRealtorPoints.runningTotal,
          bonusLevelRank: state.selectedRealtorPoints.bonusLevelRank,
          bonusLevelName: state.selectedRealtorPoints.bonusLevelName,
          realtorsPoints: approvalSelectedRealtorPoints
        }
      };

      break;
      case types.REALTOR_POINT_DENY:
        const denySelectedRealtorPoints = state.selectedRealtorPoints.realtorsPoints.map(pointObject =>{
          if (pointObject.nodeName === action.payload) {
            pointObject.approved = false
            pointObject.approvedBy = action.payloadTwo
          }
        })

        state = {
          ...state,
          selectedRealtorPoints: {
            currentTotal: state.selectedRealtorPoints.currentTotal,
            runningTotal: state.selectedRealtorPoints.runningTotal,
            bonusLevelRank: state.selectedRealtorPoints.bonusLevelRank,
            bonusLevelName: state.selectedRealtorPoints.bonusLevelName,
            realtorsPoints: denySelectedRealtorPoints
          }
        };
      break;
      case types.REALTOR_POINT_DELETE:
        const deleteSelectedRealtorPoints = state.selectedRealtorPoints.realtorsPoints
          
        const resultDelete = deleteSelectedRealtorPoints.filter(pointObject => pointObject.nodeName != action.payload);
        state = {
          ...state,
          selectedRealtorPoints: {
            currentTotal: state.selectedRealtorPoints.currentTotal,
            runningTotal: state.selectedRealtorPoints.runningTotal,
            bonusLevelRank: state.selectedRealtorPoints.bonusLevelRank,
            bonusLevelName: state.selectedRealtorPoints.bonusLevelName,
            realtorsPoints: resultDelete
          }
        };
      break;
      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allRealtors: action.payloadTwo ? state.allRealtors : [],
        selectedRealtor: action.payloadTwo ? state.selectedRealtor :  {
          email: "",
          name: "",
          officeName: "",
          region: "",
          uid: ""
        },
        selectedRealtorPoints: action.payloadTwo ? state.selectedRealtorPoints :  {
          currentTotal: 0,
          runningTotal: 0,
          bonusLevelRank: -1,
          bonusLevelName: "",
          realtorsPoints: []
        }
      };
      break;
      default:
      break;    
    }

    return state;
};


export default realtorsReducer;


// WEBPACK FOOTER //
// ./src/reducers/realtorsReducer.js